export default "__VITE_ASSET__BRdKdklq__"